import { Box, CircularProgress, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Filter from "./filter/filter";
import OutSource from "./outsource";
import { getGeneSymbolKey } from "../utils/helpers";
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
  },
  evenly: {
    display: "flex",
    justifyContent: "space-evenly",
    alignContent: "center",
    width: 300,
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
}));

function AdvanceFilter({
  fields,
  setAdvanceFilter,
  version,
  advanceFilter,
  reportMeta,
  schemaId,
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [visibleFields] = useState(fields);
  const callback = (panel, pheno, filtersets, colName) => {
    const tmpColName = getGeneSymbolKey(reportMeta.pipeline_class, version);

    let rules = JSON.parse(JSON.stringify(advanceFilter.rules));
    rules.push({
      combinator: "and",
      id: "g-" + Math.random().toString(),
      not: false,
      rules: [],
    });

    if (panel.length === 0 && pheno.length === 0) {
      filtersets.forEach((filterset) => {
        if (filterset.name !== "") {
          rules[rules.length - 1].rules.push({
            field: tmpColName,
            id: "r-0." + (Math.random() * 1000).toString(),
            operator: "in",
            value: filterset.values.join(","),
          });
        }
      });
    }

    setAdvanceFilter((prev) => ({ ...prev, rules: [...rules] }));

    for (let i = 0; i < pheno.length; i++) {
      const item = pheno[i];
      rules[rules.length - 1].rules.push({
        field: tmpColName,
        id: "r-0." + (Math.random() * 1000).toString(),
        operator: "in",
        value: item.hugo_symbol.join(","),
      });
      setAdvanceFilter((prev) => ({ ...prev, rules: [...rules] }));
    }

    for (let i = 0; i < panel.length; i++) {
      const item = Object.values(panel[i][1])
        .map((value) => value.genes.map((val) => val.label).join(","))
        .map((genes) => genes.replaceAll(" ", ""))
        .toString();
      rules[rules.length - 1].rules.push({
        field: tmpColName,
        id: "r-0." + (Math.random() * 1000).toString(),
        operator: "in",
        value: item,
      });
      setAdvanceFilter((prev) => ({ ...prev, rules: [...rules] }));
    }
  };

  if (!visibleFields) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );
  } else {
    return (
      <>
        <Alert severity="warning" className={classes.alert}>
          {t(
            "Filters applied in the variant table will be overridden when advanced filtering is applied."
          )}
        </Alert>
        <Filter
          setAdvanceFilter={setAdvanceFilter}
          advanceFilter={advanceFilter}
          schemaId={schemaId}
          fields={visibleFields}
        />
        <Box className={classes.root}>
          <OutSource
            callback={callback}
            schemaId={schemaId}
            type={"hpo"}
            label={t("HPO Filter")}
          />
          <OutSource
            callback={callback}
            type={"panel"}
            schemaId={schemaId}
            label={t("Massive Panel")}
          />
          <OutSource
            callback={callback}
            type={"filtersets"}
            colName={getGeneSymbolKey(reportMeta.pipeline_class, version)}
            schemaId={schemaId}
            label={t("Gene Symbol Filterset")}
          />
        </Box>
      </>
    );
  }
}

export default AdvanceFilter;
